// /**
//  * lazysizes - v5.3.2
//  * https://github.com/aFarkas/lazysizes
//  */
// import "lazysizes";
// import "lazysizes/plugins/aspectratio/ls.aspectratio"; // For Responsive, Smartphone(+ Desktop).CLS(Cumulative Layout Shift).
// // import "lazysizes/plugins/unveilhooks/ls.unveilhooks.js"; // Used for backgrounds.
// // import "lazysizes/plugins/parent-fit/ls.parent-fit";// lazySizes parent fit extension

// /**
//  * GSAP + Accordion + DetailsSummary
//  */
// // import gsapAccordionDetailsSummary from './modules/gsapAccordionDetailsSummary';
// // gsapAccordionDetailsSummary();

// /**
//  * accordion-js - v3.3.4
//  * https://github.com/michu2k/Accordion
//  * https://michu2k.github.io/Accordion/
//  */
// // import 'accordion-js/dist/accordion.min.css';
// // import AccordionJs from './modules/accordion-js';
// // AccordionJs();

// // /*!
// //  * Micromodal - v0.4.10
// //  * https://github.com/ghosh/Micromodal
// //  * MIT License
// //  * Copyright (c) 2017 Indrashish Ghosh
// //  */
// // import MicroModal from "micromodal"; // es6 module
// // MicroModal.init({
// //   disableScroll: true, // モーダル裏の画面スクロールを制御します。デフォルト値は false（スクロールする）です。
// //   awaitOpenAnimation: true, // モーダルを閉じるときの CSS アニメーションを待つかどうかを制御します。
// //   awaitCloseAnimation: true, // モーダルを閉じるときの CSS アニメーションを待つかどうかを制御します。
// // });

// /**
//  * Splide - v4.1.4
//  * https://github.com/Splidejs/splide
//  */
// // import Splide from '@splidejs/splide'; // ie11が動かない
// // var splide = new Splide( '#page_fv_slider',{
// //     type          : 'loop',
// //     perPage       : 1,
// //     arrows        : false,
// //     autoplay      : true,
// //     speed         : 1500,
// //     interval      : 4000,
// //     keyboard      : true,
// //     pauseOnHover  : false,
// //     pauseOnFocus  : false,
// //     pauseOnInteraction: false, // 追加
// //     easing: 'ease-in-out',
// //     breakpoints: {
// //         //スマホ
// //         640: {
// //             speed: 1000,
// //             // drag: false, // スマホは追加 これが有効になっている場合、スライダーが動いている間にクリックができない。
// //         }
// //       }
// // });
// // splide.mount();

// // /**
// //  * Swiper v10.1.0
// //  */
// // import swiper from "./modules/swiper/swiper"; // ie11が動かない
// // swiper();

// /**
//  * GSAP - v3.12.2 + ScrollTrigger + Animation / Vanilla Js
//  */
// // import gsapAnimation from './modules/gsap';
// // gsapAnimation();

// /**
//  * Tab / Vanilla Js
//  */
// // import tab from "./modules/tab";
// // tab();

// /**
//  * External Link / Vanilla Js
//  */
// import * as common from "./modules/common";
// common.externalLink(); // for Desktop + Smartphone Corp.ver
// common.clientNavbarHeaderH(); // For Smartphone Corp.ver Only
// // common.clientNavbarH();// For Smartphone SHOEPLAZA&TSRC.ver Only

// /**
//  * New 20024.4.22
//  * Social Share Links / Vanilla Js
//  */
// import socialShareLinks from "./modules/social_share_links";
// socialShareLinks(); // For Smartphone + Desktop Only

// /**
//  * 使用していない
//  * Social Share Button / Vanilla Js
//  */
// import * as ssb from "./modules/social_share_button";
// // ssb.desktopSocialShareButton(); // For Desktop Only
// ssb.smartphoneSocialShareButton(); // For Smartphone Only

// /**
//  * Smooth Anchor Scroll / Vanilla Js
//  */
// // import * as sas from "./modules/smooth_anchor_scroll";
// // sas.desktopSmoothAnchorScroll();// For Desktop Only headerが固定されていない場合 Corp.ver
// // sas.smartphoneSmoothAnchorScroll();// For Smartphone Only header分の高さをずらす場合 Corp.ver

// /**
//  * Clipboard Copy / Vanilla Js
//  */
// // import clipboardCopy from "./modules/clipbord_copy";
// // clipboardCopy();

// /**
//  * YoutubePlayerApi / Vanilla Js
//  */
// // import './modules/youtube_player_api/my_youtube_player_api.scss';
// // import YoutubePlayerApi from './modules/youtube_player_api/youtube_player_api';
// // YoutubePlayerApi();

// /**
//  * 日時によって切り替える / Vanilla Js
//  */
// // import jsViewTimer from './modules/view_timer';
// // jsViewTimer();

// /**
//  * Scroll In / Vanilla Js
//  */
// // import jsScrollIn from './modules/scroll_in';
// // jsScrollIn();

// /**
//  * Simple Slide / Vanilla Js
//  */
// // import jsSimpleSlide from './modules/simple_slide';
// // jsSimpleSlide();

// /**
//  * lity / jQuery library
//  * Lightweight, accessible and responsive lightbox.
//  * https://github.com/jsor/lity
//  * https://sorgalla.com/lity/
//  */
// // import lity from './modules/lity';// for Desktop + Smartphone
// // lity();// for Desktop + Smartphone

// /**
//  * flexslider / jQuery library
//  */
// // import flexslider from './modules/flexslider';
// // flexslider();

/*
 * DropdownFilter.js / Vanilla Js
 * - ドロップダウンフィルター（西暦）でリストを絞り込む。
 * - 西暦をタップ・クリックで西暦リストを表示し、選択して、リストが絞り込む。
 * - 西暦を選択したら、ドロップダウンリストを閉じる。
 * - ドロップダウンリストの外側をクリックしたら、ドロップダウンリストを閉じる。
 * - リストには付与（`data-year`）された西暦を取得し、リストを絞り込む。
 */
import DropdownFilter from "./modules/DropdownFilter";
DropdownFilter();
